<template>
    <el-select :placeholder="placeholder" :value="valueModel" @input="input" filterable remote
               :remote-method="remoteMethod" :clearable="true" @change="val => $emit('change', val)"
               popperClass="custom-select" @click.native.once="remoteMethod('')">
        <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in list">
            <div>
                <span class="pull-left">{{ item.name }}</span>
            </div>
          <core-goods-field :optionItem="item" class="clearfix"/>
        </el-option>
    </el-select>
</template>
<script>
  import {remoteSelect} from '../mixins/componentMixin';

  export default {
    name: 'goods-select',
    mixins: [remoteSelect]
  };
</script>
